<div [ngClass]="{'main-content-container': !dialogData}">
    <div [ngClass]="{'main-container-body': !dialogData}">
        @if (!utilService.isMobile() && dietMeal) {
        <div class="page-title-container d-flex">
            <div class="page-title flex-grow-1">
                <div class="mb-0">
                    <div class="d-flex align-items-center">
                        <div class="pl-2 pr-2">
                            <a class="d-inline-flex" (click)="previous()" href="javascript:void(0)">
                                <img src="assets/images/grid-back.png">
                            </a>
                        </div>

                        <div class="text-capitalize">
                            {{'menu.diet_plan_history' | translate |async }}
                        </div>

                    </div>
                </div>
            </div>
        </div>
        }


        @for (history of dietHistory; track history; let h = $index) {
        <div class="diet-history-container mb-3">
            <div class="history-date-header p-2 font-weight-bold"
                [ngClass]="typeof history.orderPlacedForDate === 'number' ? 'current-diet-heading' : 'diet-history-heading'">
                {{ getHeader(history.orderPlacedForDate) }}
            </div>
            @for (p of history.meal_timing; track p; let i = $index) {
            <div class="row">
                <div class="col-12">
                    <div id="accorion-{{h}}-{{i}}">
                        <div class="accordion pt-1 pb-1">
                            <div class="accordion-header" data-toggle="collapse">
                                <div class="d-flex align-items-center justify-content-between">
                                    <div class="accordion-title text-capitalize pl-3">
                                        <span class="accordion-title text-capitalize float-left">
                                            {{ p.mealTime }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            @if (openAccordian[i]) {
                            <div class="accordion-body show" id="accordion-{{i+1}}"><!-- -->
                                <div class="col-12 p-0 table-last-elements">
                                    @if (resourceDef) {
                                    <dhs-editable-grid [json]="resourceDef" #formobj
                                        [config]="getConfig(p.mealTimeCode,history,h)"
                                        (listen_changes)="listen_changes($event,i)" class="diet-meal-item-c">
                                    </dhs-editable-grid>
                                    }
                                </div>
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
            }
        </div>
        }
    </div>
</div>